import { takeEvery } from 'redux-saga/effects';
import { getSampleSuccess } from '../../actions/sample';

export function* watchSample() {
    yield takeEvery(getSampleSuccess, sample);
}

function* sample() {}